import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetBaseRoleList = () => {
  const [loading, setLoading] = useState(true);
  const [roleList, setRoleList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getRoleList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/Role/List/BaseRole', { params })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setRoleList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              name: element.name,
              editable: element.editable,
            }));

            return { ...prev, [params?.Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getRoleList, loading, roleList, pageRef];
};

export { useGetBaseRoleList };
